<div class="dashboard" *ngIf="!pageLoading">
  <div class="wrapper">
    <div class="content-wrapper">

      <app-announcement
        class="content-wrapper__announcement"
      ></app-announcement>

      <div class="dashboard-layout">
        <div class="dashboard-layout__left">
          <app-navigation
            class="content-wrapper__nav"
          ></app-navigation>

          <app-news-widget
            class="content-wrapper__news"
            [content]="newsData"
          ></app-news-widget>
        </div>

        <div class="dashboard-layout__right">
          <app-account
            [clientIp]="clientIp"
            [user]="user"
            [voluntaryBlocking]="voluntaryBlocking"
            class="content-wrapper__account"
          ></app-account>

          <app-available-traffic-packs
            class="content-wrapper__available-packs"
            [disabled]="voluntaryBlocking"
            [trafficPacks]="availableTrafficPacks"
            [pnoId]="user.pno"
          ></app-available-traffic-packs>

          <app-active-packs
            class="content-wrapper__active-packs"
            [activePack]="activePack"
          ></app-active-packs>
        </div>
      </div>

    </div>

  </div>
</div>

<p-toast></p-toast>
<app-loader *ngIf="pageLoading"></app-loader>
